import pinkThemePallete from "../pink/pink.theme.palette";
import { getTheme } from "../themes.service";

const pinkTheme = getTheme(pinkThemePallete);

export default pinkTheme;
